import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { internalTimelineExportSearchSchema } from '@/features/views/components/export/ExportTimelinePage';

// The roadmap export worker (apps/roadmap/src/worker/export/export-consumer.ts) still requests /timeline URLs.
export const Route = createFileRoute(
  '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png',
)({
  validateSearch: zodValidator(internalTimelineExportSearchSchema),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/roadmap/png',
      params,
      search,
      replace: true,
    });
  },
});
